export default {
      id: "Icon--socialFacebook-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--socialFacebook",
      toString: function () {
        return this.url;
      }
    }